/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractSnapshotFormComponent,
  formSchemaBuilderByEntityConfig,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  getFormStateSnapshotValue,
  getRouteInitData,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { assign } from 'lodash';
import {
  CS_MASTER_ITEM_INFO_ENTITY_CONFIG,
  CSMasterItemInfo,
} from '../../../resources/cs-master.model';

@Component({
  standalone: false,
  selector: 'gh-cs-master-detail-item-form',
  templateUrl: 'cs-master-detail-item-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsMasterDetailItemFormComponent extends AbstractSnapshotFormComponent<CSMasterItemInfo>
  implements OnInit {

  constructor(private route: ActivatedRoute,
              private formStateBuilder: FormStateBuilder) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    assign(this, getRouteInitData(this.route));
  }

  protected buildForm(snapshot: FormStateSnapshot<CSMasterItemInfo>): FormState<CSMasterItemInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      snapshot,
      children: {
        ...formSchemaBuilderByEntityConfig(getFormStateSnapshotValue(snapshot), CS_MASTER_ITEM_INFO_ENTITY_CONFIG),
        description: void 0,
      },
    });
  }
}
